import { Dispatch, SetStateAction, useEffect } from 'react'

export function useDebounceState(
  debounceState: boolean,
  setDebounceState: Dispatch<SetStateAction<boolean>>,
  delay = 2000
) {
  useEffect(
    function clearDebounce() {
      const clearDebounceState = () => setDebounceState(false)
      const debounceTimer = setTimeout(clearDebounceState, delay)
      const cleanUpTimeout = () => clearTimeout(debounceTimer)
      return cleanUpTimeout
    },
    [debounceState, setDebounceState, delay]
  )
}
